import type { ReactNode } from 'react';
import { ArrowLeft } from 'lucide-react';
import { useLocation, useNavigate } from 'react-router-dom';

/**
 * Portal chrome for tools that are shared with the staff app (flight search, alerts, FLIFO, MCT) and for My Bookings.
 * Those pages have no way back of their own, and they must stay unchanged for staff, so the way back is added here
 * at the portal route. Navigation only: the session is untouched, nothing is read or written.
 */
export function PaxToolShell({ children }: { children: ReactNode }) {
  const navigate = useNavigate();
  const location = useLocation();
  const homePath = location.pathname.startsWith('/propeller') ? '/propeller' : '/';
  return (
    <div className="min-h-screen bg-slate-50 dark:bg-slate-900" data-testid="pax-tool-shell">
      <nav aria-label="Portal" className="border-b border-slate-200 bg-white px-4 py-2 dark:border-slate-700 dark:bg-slate-800">
        <button
          type="button"
          onClick={() => navigate(homePath)}
          className="flex items-center gap-1 rounded text-sm text-slate-600 hover:text-slate-900 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600 dark:text-slate-300 dark:hover:text-white"
        >
          <ArrowLeft className="h-4 w-4" aria-hidden="true" /> Dashboard
        </button>
      </nav>
      {children}
    </div>
  );
}

export default PaxToolShell;
